
import React, { useEffect, useState } from 'react';
import { ShareIcon } from '../../Icons';

interface FloatingActionMenuProps {
    selectedCount: number;
    isSelectionMode: boolean;
    onClick: () => void;
}

export const FloatingActionMenu: React.FC<FloatingActionMenuProps> = ({ 
    selectedCount, 
    isSelectionMode, 
    onClick 
}) => {
    const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);

    useEffect(() => {
        const checkFilterModal = () => {
            setIsFilterModalOpen(document.body.hasAttribute('data-filter-modal-open'));
        };
        checkFilterModal();
        const observer = new MutationObserver(checkFilterModal);
        observer.observe(document.body, { attributes: true, attributeFilter: ['data-filter-modal-open'] });
        return () => observer.disconnect();
    }, []);

    if (isFilterModalOpen) {
        return null;
    }

    return (
        <div data-floating-action="true" className="floating-share-btn fixed right-8 bottom-8 z-[70] animate-fade-in-up">
            <button 
                onClick={onClick} 
                className="flex flex-col items-center justify-center bg-green-600 hover:bg-green-700 text-white rounded-full shadow-2xl transition-all transform hover:scale-105 active:scale-95 group w-20 h-20 sm:w-24 sm:h-24"
            >
                <div className="flex flex-col items-center">
                    <ShareIcon className="w-6 h-6 sm:w-8 sm:h-8 mb-1 group-hover:rotate-12 transition-transform"/>
                    <span className="text-[10px] sm:text-xs font-black uppercase leading-none tracking-tighter">
                        {isSelectionMode ? 'Finalizar' : 'Compartir'}
                    </span>
                    {selectedCount > 0 && (
                        <span className="text-lg sm:text-xl font-black mt-0.5 leading-none">
                            {selectedCount}
                        </span>
                    )}
                </div>
            </button>
        </div>
    );
};
